import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .PlayerMenu.desktop .menu-item--upgrade-to-stv-player,
  .PlayerMenu.desktop .menu-item--subscribe-to-stv-player {
    display: none;
  }

  .live-card {
    gap: 8px;
  }

  .live-card.active {
    background: ${colors.ctvBg};
  }
`
